import { useMemo } from "react";
import { call, METHODS } from "../http-client"
import { useMutation } from "@tanstack/react-query";

export default function useTracking(feature) {
    const trackingMutation = useMutation({
        mutationFn: ({action,context}) => { return call(METHODS.POST,'','track',{ feature,action,context }) }
    });

    const returnValue = useMemo(() => ({
        track: (action,context) => { setTimeout(() => trackingMutation.mutate({action, context}), 0) },
    }),[trackingMutation])

    return returnValue
    
}